import { Component, OnInit, Input, EventEmitter, OnDestroy, HostListener } from '@angular/core';
// import { Subscription } from 'rxjs';
// import { SharingModuleService } from './sharingModule.service';


@Component({
    selector: '[sharing-module]',
    templateUrl: './sharingModule.component.html'
})
export class SharingModuleComponent implements OnInit, OnDestroy {

    constructor() {}


    ngOnInit() {
    }

    ngOnDestroy() {
    }
}